import { EditProjectContextProps } from "../../EditProjectContext";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";

export default (
  { project, setProject }: EditProjectContextProps,
  spdrOrPdsr: number | undefined
) => {
  const ltlPipelines = project?.ltlPipelines?.map((item: LtlPipelineViewModel) => {
    if (item?.SpdrId !== spdrOrPdsr && item?.PdsrId !== spdrOrPdsr) {
      return item;
    }

    return {
      ...item,
      routing: [],
      IsFinished: false,
      SupplierTransitTime: "0",
    };
  });

  setProject({ ...project, ltlPipelines });
};
